/*! Copyright (c) Safe As Milk. All rights reserved. */
class ProductForm extends HTMLElement {
    #boundSubmit;
    #eventAttached;
    static #formsBeingProcessed=[];
    constructor() {
        super();
        this.#boundSubmit = this.submit.bind(this);
    }
    connectedCallback() {
        this.#eventAttached = false;
        setTimeout((() => {
            this.form = this.querySelector("form");
            this.idInput = this.form.querySelector('input[name="id"]');
            this.submitButtons = this.form.querySelectorAll('[name="add"]');
            this.stagedActions = this.form.querySelectorAll("staged-action");
            this.idInput.removeAttribute("disabled");
            this.notifyOnAdd = this.hasAttribute("notify-on-add");
            this.#eventAttached = true;
            this.form.addEventListener("submit", this.#boundSubmit);
        }));
    }
    disconnectedCallback() {
        if (this.#eventAttached) {
            this.#eventAttached = false;
            this.form.removeEventListener("submit", this.#boundSubmit);
        }
    }
    async submit(e) {
        e.preventDefault();
        const data = new FormData(e.target);

        this.toggleAttribute('data-is-updating');

        // Personalization functionality
        const personalizationForm = this.form.querySelector('.js-personalization-form');

        if (!!(personalizationForm)) {
            const personalizationFormData = [];

            personalizationForm.querySelectorAll('input')?.forEach((input) => {
                personalizationFormData.push({
                    key: input.dataset.key,
                    value: input.value
                });
            });

            data.append('properties[_personalization]', JSON.stringify(personalizationFormData));
        }

        const uuidInputs = this.form.querySelectorAll('.js-product-uuid-input');
        let doesNotHaveUuid = true;

        if (!!(uuidInputs) && uuidInputs.length > 0) {
            uuidInputs.forEach((input) => {
                if (Number(input.dataset.variantId) === Number(this.idInput.value)) {
                    input.disabled = false; // Enable the input if the variant is the same
                    doesNotHaveUuid = false;
                } else {
                    input.disabled = true; // Disable the input if the variant is different
                }
            });
        }

        if (doesNotHaveUuid) {
            const uuid = window.crypto.randomUUID();

            // Add element in case customer wants to add more from the same product form
            this.form.insertAdjacentHTML('beforeend', `<input type="hidden" name="properties[_uuid]" value="${uuid}" data-variant-id="${this.idInput.value}" class="js-product-uuid-input">`);

            data.append('properties[_uuid]', uuid);
        }

        data.append('sections', sectionsToFetch);

        try {
            this.removeError();

            if (!!(this.stagedActions) && this.stagedActions.length > 0) {
                this.stagedActions.forEach(async (stagedAction) => {
                    await stagedAction.setState("DOING");
                });
            }

            cartAdd(data)

            if (!!(this.stagedActions) && this.stagedActions.length > 0) {
                this.stagedActions.forEach(async (stagedAction) => {
                    await stagedAction.setState("DONE");
                });
            }
            if (this.notifyOnAdd) {
                if (!this.closest(".modal--cart")) {
                    const cart = document.querySelector(".modal--cart");
                    if (cart && !cart.shown) {
                        cart.open();
                    } else if (cart && cart.interval) {
                        cart.interval.reset();
                        cart.interval.start();
                    }
                }
            }

            this.removeAttribute('data-is-updating');
        } catch (error) {
            this.#renderError(error.message);
            if (!!(this.stagedActions) && this.stagedActions.length > 0) {
                this.stagedActions.forEach(async (stagedAction) => {
                    await stagedAction.setState("IDLE");
                });
            }

            this.removeAttribute('data-is-updating');
        }
    }
    removeError() {
        const error = this.querySelector(".errors");
        if (!error) return;
        error.remove();
    }
    #renderError(message) {
        this.removeError();
        if (!!(this.submitButtons) && this.submitButtons.length > 0) {
            const error = document.createElement("div");
            error.classList.add("errors", "qty-error", "u-small");
            error.innerHTML = message;

            this.submitButtons.forEach((submitButton) => {
                submitButton.before(error);
            });
        }
    }
}

customElements.define("product-form", ProductForm);
//# sourceMappingURL=product-form.js.map
